import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const TimeBasedLoader = ({ startLoader }) => {
	const [loaderOne, setLoaderOne] = useState(true);
	const [loaderTwo, setLoaderTwo] = useState(false);

	useEffect(() => {
		const loaderOneTimer = setTimeout(() => {
			setLoaderOne(false);
			setLoaderTwo(true);
		}, 8000);
		return () => clearTimeout(loaderOneTimer);
	}, []);

	return (
		<Modal show={startLoader} className="presentation-modal" centered>
			<Modal.Body className="p-0">
				{loaderOne && (
					<div className="loader-wrapper" style={{ padding: '30px 0 40px' }}>
						<div className="download-circular1">
							<div className="inner1"></div>
							<div className="number1"></div>
							<div className="circle1">
								<div className="bar1 left1">
									<div className="progress1"></div>
								</div>
								<div className="bar1 right1">
									<div className="progress1"></div>
								</div>
							</div>
						</div>
					</div>
				)}
				{loaderTwo && (
					<div className="loader-wrapper" style={{ padding: '30px 0 40px' }}>
						<div className="download-circular2">
							<div className="inner2"></div>
							<div className="number2">
								<img src={process.env.PUBLIC_URL + '/icons/loader-arrow.svg'} alt="" />
							</div>
							<div className="circle2">
								<div className="bar2 left2">
									<div className="progress2"></div>
								</div>
								<div className="bar2 right2">
									<div className="progress2"></div>
								</div>
							</div>
						</div>
					</div>
				)}
				{loaderOne && (
					<p className="text-center regular-14 gray_dark_02" style={{ paddingBottom: '40px' }}>
						Preparing your file.....
					</p>
				)}
				{loaderTwo && (
					<p className="text-center regular-14 gray_dark_02" style={{ paddingBottom: '40px' }}>
						Downloading.......
					</p>
				)}
			</Modal.Body>
		</Modal>
	);
};
export default TimeBasedLoader;
